import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export type GetMerchantUnPaidHistoryRequest = {
  page: number;
  size: number;
  orderByDesc?: boolean;
  orderBy?: string;
  status?: string;
  filters?: Array<{
    field: string;
    values: string[];
    valueType: number;
    operationType: number;
  }>;
  [key: string]: string | number | boolean | undefined | Array<any>;
};

export type MerchantUnPaidHistoryItem = {
  id?: number;
  totalVPos: number;
  totalFPos: number;
  term: string;
  reservBalance: number;
  reservBalanceLastDate: string;
  balanceDifference: number;
};

export type MerchantUnPaidHistoryResponse = {
  currentPage: number;
  pageSize: number;
  totalPages: number;
  totalItems: number;
  orderBy: string;
  orderByDesc: boolean;
  result: MerchantUnPaidHistoryItem[];
};

async function getMerchantUnPaidHistory(
  data: GetMerchantUnPaidHistoryRequest
): Promise<BaseResponse<MerchantUnPaidHistoryResponse>> {
  try {
    const response = await axiosInstance.post("/Merchant/GetMerchantUnPaidHistory", data);
    
    if (response.status === 204) {
      return {
        isSuccess: true,
        message: "Veri bulunamadı",
        errorCode: null,
        requestId: "",
        data: {
          currentPage: data.page || 0,
          pageSize: data.size || 25,
          totalPages: 0,
          totalItems: 0,
          orderBy: data.orderBy || "Term",
          orderByDesc: data.orderByDesc || true,
          result: []
        }
      };
    }
    
    return response.data;
  } catch (ex) {
    if (ex instanceof AxiosError && ex.response?.data) {
      throw ex.response.data.error;
    }
    throw ex;
  }
}

export function useGetMerchantUnPaidHistory() {
  return useMutation<BaseResponse<MerchantUnPaidHistoryResponse>, Error, GetMerchantUnPaidHistoryRequest>(
    getMerchantUnPaidHistory
  );
}